import { render } from "./Bienvenida.vue?vue&type=template&id=344dba39&scoped=true"
import script from "./Bienvenida.vue?vue&type=script&lang=js"
export * from "./Bienvenida.vue?vue&type=script&lang=js"

import "./Bienvenida.vue?vue&type=style&index=0&id=344dba39&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-344dba39"

export default script